module.exports = __webpack_public_path__ + "img/k12_1.34c3be03.png";